import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Marca do Compilações: o símbolo da Nasajon (quadrado arredondado em três tons de azul) com uma timeline de versões no
 * lugar do "N" — a linha do tempo com a versão mais recente em destaque e as barras do feed. É o mesmo desenho de
 * `public/favicon.svg`. Decorativo: o nome "Compilações" vem escrito ao lado.
 */
export function LogoCompilacoes({ className, animado = false }: { className?: string; animado?: boolean }) {
  // `animado`: a timeline se monta (linha, pontos de cima para baixo, barras do feed); usado na tela de entrada.
  const ponto = (atraso: number) =>
    animado ? { className: 'cmp-logo-ponto', style: { animationDelay: `${atraso}ms` } } : {};
  const barra = (atraso: number) =>
    animado ? { className: 'cmp-logo-barra', style: { animationDelay: `${atraso}ms` } } : {};
  const recorte = React.useId();
  return (
    <svg viewBox="0 0 556 556" aria-hidden="true" focusable="false" className={cn('shrink-0', className)}>
      <defs>
        <clipPath id={recorte}>
          <rect width="556" height="556" rx="96" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${recorte})`}>
        <rect width="556" height="556" fill="#0064bd" />
        <rect x="421" width="135" height="135" fill="#0083db" />
        <rect y="135" width="421" height="421" fill="#00449f" />
        <line
          x1="135"
          y1="215"
          x2="135"
          y2="455"
          stroke="#fff"
          strokeWidth="20"
          strokeLinecap="round"
          opacity=".55"
          {...(animado ? { className: 'cmp-aparecer' } : {})}
        />
        <circle cx="135" cy="215" r="40" fill="#fff" {...ponto(120)} />
        <circle cx="135" cy="335" r="30" fill="#fff" {...ponto(260)} />
        <circle cx="135" cy="455" r="30" fill="#fff" {...ponto(400)} />
        <rect x="215" y="196" width="190" height="38" rx="19" fill="#fff" {...barra(200)} />
        <rect x="215" y="316" width="150" height="38" rx="19" fill="#fff" opacity=".8" {...barra(340)} />
        <rect x="215" y="436" width="170" height="38" rx="19" fill="#fff" opacity=".6" {...barra(480)} />
      </g>
    </svg>
  );
}
